import type { AppConfig } from '../types';

export const config: AppConfig = {
  apiBase: import.meta.env.VITE_API_BASE || '/api',
  recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '',
};

export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;
